<script setup lang="ts">
import type { PropType } from 'vue';

import type { Breadcrumb } from '~/types/breadcrumb.type';

const { items, color } = defineProps({
    items: { type: Array as PropType<Breadcrumb[]>, required: true },
    color: { type: String as PropType<'neutral' | 'inherit'>, default: 'neutral' },
});

// COMPOSABLES
const localePath = useLocalePath();

// DATA
const breadcrumbItems = computed(() => items.map(i => ({ ...i, to: localePath(i.to) })));
const ui = computed(() => {
    switch (color) {
        case 'inherit':
            return {
                link: 'text-inherit',
            };
    }
});
</script>

<template>
    <UBreadcrumb :items="breadcrumbItems" :ui="ui">
        <template #separator>
            <span class="mx-2" :class="{ 'text-muted': color === 'neutral', 'text-inherit': color === 'inherit' }">/</span>
        </template>
    </UBreadcrumb>
</template>
